<template>
  <div>
    <div id="sumsub-websdk-container"></div>
  </div>
</template>

<script>
import { apiGetVerificationToken } from '@/resource';
import sumsub from '@sumsub/websdk';
import { I18N_PLATFORM_MAP } from '@/constants/language';

export default {
  name: 'SumsubAdvancedKyc',
  data() {
    return {};
  },
  mounted() {
    this.initializeSumsub();
  },
  computed: {
    sumsubLang() {
      switch (this.lang) {
        case 'zh_CN':
          return 'zh';
        case 'zh_TW':
          return 'zh-tw';
        default:
          return I18N_PLATFORM_MAP[this.lang] || 'en';
      }
    }
  },
  methods: {
    createAccessToken() {
      return apiGetVerificationToken(4);
    },
    async initializeSumsub() {
      const accessToken = await apiGetVerificationToken(4);
      const snsWebSdkInstance = sumsub
        .init(accessToken.data.data, this.createAccessToken)
        .withConf({
          lang: this.sumsubLang
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        .on('idCheck.onApplicantStatusChanged', statusPayload => {
          if (statusPayload.reviewStatus === 'completed') {
            // 完成
            this.$store.dispatch('common/actionAccountAuditStatus');
            if (statusPayload.reviewResult.reviewAnswer === 'RED') {
              // 失败
              // 不能立马拿到更新的回调结果
              this.$emit('onFailedSumsub');
            }
          }
        })
        .build();

      snsWebSdkInstance.launch('#sumsub-websdk-container');
    }
  }
};
</script>

<style lang="scss"></style>
